import { useEffect } from 'react';
import { useViolationsStore } from 'src/context/ViolationsContext';
import { isStowagePlanValid } from 'src/utils/stowage/violations/violationsUtils';

const useUpdateIsStowagePlanValid = () => {
    const { violations, setIsStowagePlanValid } = useViolationsStore();

    useEffect(() => {
        setIsStowagePlanValid(isStowagePlanValid(violations));
    }, [violations]);
};
export default useUpdateIsStowagePlanValid;
